import { Link } from '@tanstack/react-router';
import { ChevronUpIcon, PackageIcon, Settings } from 'lucide-react';
import type { ProjectSimplified } from '@/api/projects/types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

type Props = {
  project: ProjectSimplified;
};

export const ProjectItem = ({ project }: Props) => {
  return (
    <Link
      to="/projects/$projectId/requests"
      params={{ projectId: project.id }}
      search={{ status: 'pending' }}
      className="grow"
    >
      <Card className="relative justify-between min-h-52 gap-5 flex w-auto flex-col transition-colors hover:border-muted-foreground/50">
        <CardHeader>
          <div className="flex flex-row">
            <CardTitle
              title={project.name}
              className="line-clamp-1 text-xl leading-normal break-words mr-2"
            >
              {project.name}
            </CardTitle>
            <Link
              to="/projects/$projectId/settings"
              params={{ projectId: project.id }}
              className="group absolute flex items-center justify-center rounded-md right-2 top-2 size-8 text-sm text-muted-foreground transition-all hover:text-foreground hover:bg-muted-foreground/10"
            >
              <Settings size={16} className="transition-transform group-hover:rotate-180" />
            </Link>
          </div>
          <CardDescription className="line-clamp-2">{project.description}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-row items-center gap-4">
            <div className="flex flex-1 flex-col gap-0.5">
              <div className="flex flex-row items-center gap-1 text-sm text-muted-foreground">
                <PackageIcon size={16} />
                <span>Requests</span>
              </div>
              <span className="text-3xl font-bold">{project.requestsCount || 0}</span>
            </div>
            <div className="flex flex-1 flex-col gap-0.5">
              <div className="flex flex-row items-center gap-1 text-sm text-muted-foreground">
                <ChevronUpIcon
                  className="text-lime-600 drop-shadow-[0_0_2px_rgba(163,230,53,1)] dark:text-lime-400"
                  size={16}
                />
                <span>Upvotes</span>
              </div>
              <span className="text-3xl font-bold">{project.votesCount || 0}</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
